import React, { useEffect, useState, useCallback, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';


export default function BooleanInput({ cellValue, handleInputChange }) {
  
  return (
    <Input                
      type="checkbox"
      onChange={handleInputChange}
      checked={cellValue}      
    />
  );
}

BooleanInput.propTypes = {
  cellValue: PropTypes.boolean,
  handleInputChange: PropTypes.func,
};

BooleanInput.defaultProps = {
  cellValue: false,  
  handleInputChange: () => {},  
};

